import ApiService from "@/common/api.service"

export const LoginService = {
    forgotCreate(params) {
        return ApiService.patch("user/forgotPassword", params);
    },
    resetPassword(slug, params) {
        return ApiService.patchBySlug("user/resetPassword", slug, params);
    },
    changePassword(params) {
        return ApiService.patch("user/changePassword", params);
    },

}